<template>
  <div>
    <h2 class="text-left alert" :class="[removed ? 'alert-danger' : 'alert-success']">
      Young Stock
      <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName)">
        <span class="glyphicon" :class="[removed ? 'glyphicon-plus' : 'glyphicon-remove']"></span>
      </a>
    </h2>
    <template v-if="!removed">
      <subsection title="Young Stock" :step-name="stepName" subsection="young_stock">
        <report-comment field_name="heading_young_stock" :model="model.COMMENTS" :heading="true"></report-comment>

        <dl class="dl-horizontal">
          <dt>Needs calf disbudding training session?</dt>
          <dd>{{ model.wants_disbud_training || '-' }}</dd>

          <dt>Calf Disbudding with VetSouth?</dt>
          <dd>{{ model.calf_bisbud_vs || '-' }}</dd>

          <dt>BVD Testing?</dt>
          <dd>{{ model.wants_ys_bvd_testing || '-' }}</dd>

          <dt>Type</dt>
          <dd>{{ model.wants_ys_bvd_testing_type || '-' }}</dd>

          <dt>DNA Testing?</dt>
          <dd>{{ model.wants_ys_dna_testing || '-' }}</dd>

          <dt>Any other young stock health issues?</dt>
          <dd>{{ model.COMMENTS.current['young_stock_issues'] || '-' }}</dd>
          <report-comment field_name="young_stock_issues" :model="model.COMMENTS"></report-comment>

          <dt>Drench Plus Consult?</dt>
          <dd>{{ model.drench_plus_consult || '-' }}</dd>

          <dt>Dry stock trace element testing?</dt>
          <dd>{{ model.dry_stock_ppp || '-' }}</dd>

          <dt>Weigh it up</dt>
          <dd>{{ model.heifer_weighing || '-' }}</dd>
        </dl>
      </subsection>
    </template>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'YoungStock',
  mixins: [mixin],
}
</script>
